export default __webpack_public_path__ + "static/media/ivisit-new-logo.3a26cbe3.svg";